import React from 'react';
import { useUpdateChecker } from '@src/hooks/useUpdateChecker';

const UpdateBanner = () => {
	const { updateAvailable, dismiss, refresh } = useUpdateChecker();

	if (!updateAvailable) return null;

	return (
		<div className="fixed bottom-6 right-6 z-[9999] animate-in slide-in-from-bottom-4 duration-300">
			<div className="flex items-center gap-3 px-5 py-3.5 bg-[var(--color-card)] border border-[var(--color-border)] rounded-2xl shadow-lg max-w-sm">
				<div className="w-9 h-9 rounded-xl bg-[var(--color-accent-light)] flex items-center justify-center shrink-0">
					<i className="pi pi-refresh text-sm text-[var(--color-accent)]" />
				</div>
				<div className="flex-1 min-w-0">
					<p className="text-sm font-semibold text-[var(--color-text-primary)]">Update available</p>
					<p className="text-xs text-[var(--color-text-tertiary)] mt-0.5">A new version is ready</p>
				</div>
				<div className="flex items-center gap-2 shrink-0">
					<button
						onClick={dismiss}
						className="px-3 py-1.5 text-xs font-medium text-[var(--color-text-tertiary)] hover:text-[var(--color-text-secondary)] transition-colors cursor-pointer bg-transparent border-none"
					>
						Later
					</button>
					<button
						onClick={refresh}
						className="px-3 py-1.5 text-xs font-medium text-[var(--color-text-inverted)] bg-[var(--color-accent)] hover:opacity-90 rounded-xl transition-opacity cursor-pointer border-none"
					>
						Refresh
					</button>
				</div>
			</div>
		</div>
	);
};

export default UpdateBanner;
